import React from 'react';
import { FormattedMessage } from 'react-intl';

import { List } from '@xingternal/list';
import { Headline } from '@xingternal/typography';

import { Column } from '../column';
import { Row } from '../row';

import * as S from './services-list.styles';

type Service = {
  label: string;
  href: string;
};

export const SERVICES: Service[] = [
  { label: 'bewerbung.com', href: 'https://bewerbung.com' },
  { label: 'lebenslauf.com', href: 'https://lebenslauf.com' },
  { label: 'praktikum-guide.com', href: 'https://praktikum-guide.com/' },
];

export const ServicesList: React.VFC = () => (
  <Row>
    <Column size={12}>
      <Headline size="large">
        <FormattedMessage id="XJM_SEO_XING_SERVICES_TITLE" />
      </Headline>
      <List>
        {SERVICES.map(({ label, href }) => (
          <S.ListItem key={href}>
            <S.Hyperlink href={href} target="_blank" rel="noopener" external>
              {label}
            </S.Hyperlink>
          </S.ListItem>
        ))}
      </List>
    </Column>
  </Row>
);
